import { generateSecureToken, API_BASE } from './utils';

//Fetch latest exchange rates
export async function fetchLatestRates() {
  const token = await generateSecureToken();
  const url = `${API_BASE}/api/fx/latest` + (token ? '?key=' + encodeURIComponent(token) : '');
  const res = await fetch(url);
  const data = await res.json();
  if (data.error) throw new Error(data.error);
  return data.rates;
}

// Fetch the sell rate (calculated_rate) for a single currency
export async function fetchSellRate(currency) {
  const token = await generateSecureToken();
  const url = `${API_BASE}/api/fx/currency?cur=${encodeURIComponent(currency)}` + (token ? '&key=' + encodeURIComponent(token) : '');
  const res = await fetch(url);
  const data = await res.json();
  if (data.error) throw new Error(data.error);
  return data.calculated_rate;
}

// Fetch both sell rate and buy rate for a single currency
export async function fetchCurrencyRates(currency) {
  const token = await generateSecureToken();
  const url = `${API_BASE}/api/fx/currency?cur=${encodeURIComponent(currency)}` + (token ? '&key=' + encodeURIComponent(token) : '');
  const res = await fetch(url);
  const data = await res.json();
  if (data.error) throw new Error(data.error);
  return { sellRate: data.calculated_rate, buyRate: data.buy_rate };
}